var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLcp1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #c9c9c9;\n        stroke: #c9c9c9;\n        stroke-miterlimit: 10;\n        stroke-width: .2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2.98 9.18 .97 9.18 .97 21.18 7 21.18 7 19.46 2.98 19.46 2.98 9.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m16.83,17.48c-.6,1.31-1.74,2-3.3,2-2.37,0-3.96-1.73-3.96-4.3s1.59-4.32,3.96-4.32c1.56,0,2.71.7,3.3,2.01l.07.15h2.32l-.13-.34c-.89-2.31-2.92-3.64-5.56-3.64-3.42,0-5.99,2.64-5.99,6.14s2.58,6.11,5.99,6.11c2.65,0,4.67-1.31,5.56-3.61l.13-.34h-2.32l-.07.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m24.8,9.18h-3.96v12h2v-4.8h1.96c3.12,0,4.23-1.85,4.23-3.58s-1.11-3.62-4.23-3.62Zm2.19,3.62c0,1.24-.72,1.84-2.19,1.84h-1.96v-3.72h1.96c1.5,0,2.19.6,2.19,1.88Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLcp1);
export default __webpack_public_path__ + "static/media/lcp-1.e673abf2ea7aa9e6f5aaefb2b72b49c5.svg";
export { ForwardRef as ReactComponent };